export default {
  SCORE_INIT: 'SCORE_INIT',
  SCORE_SET_API_REQUEST: 'SCORE_SET_API_REQUEST',
  SCORE_SET_API_ERROR: 'SCORE_SET_API_ERROR',
  CREATE_SCORE_SET: 'CREATE_SCORE_SET',
  UPDATE_SCORE_SET: 'UPDATE_SCORE_SET',
  DELETE_SCORE_SET: 'DELETE_SCORE_SET',
  RELOAD_SCORE_SETS: 'RELOAD_SCORE_SETS'
};
